import React, { useState } from 'react';
import {
  Search,
  BrainCircuit,
  Zap,
  BookMarked,
  FileSearch,
  Globe,
  Database,
  UserCircle,
  LogOut,
} from 'lucide-react';
import WebScraping from '../webScraping/WebScraping';
import Patents from '../sections/Patents';
import Apify from '../sections/Apify';
import PubMed from '../sections/PubMed';
import Scraping from '../sections/Scraping';
import Gdelt from '../sections/Gdelt';

export default function DashboardLayout({ onLogout }) {
  const [activePage, setActivePage] = useState('webScraping');

  const NavLink = ({ page, label, icon: Icon }) => {
    const isActive = activePage === page;
    return (
      <button
        onClick={() => setActivePage(page)}
        className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-all duration-200 ${
          isActive
            ? 'bg-cyan-500/20 text-cyan-300 font-semibold'
            : 'text-gray-400 hover:bg-gray-700/50 hover:text-white'
        }`}
      >
        <Icon size={20} />
        <span>{label}</span>
      </button>
    );
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen font-sans flex">
      <aside className="w-1/5 max-w-xs min-w-[250px] bg-gray-800 p-4 border-r border-gray-700 flex flex-col">
        <header className="mb-10 px-2">
          <h1 className="text-3xl font-bold text-cyan-400 flex items-center gap-3">
            <Database size={32} /> Admin Hub
          </h1>
          <p className="text-gray-500 text-sm mt-1">Data Source Management</p>
        </header>
        <nav className="flex flex-col gap-2">
          <NavLink page="webScraping" label="Web Scraping" icon={Search} />
          <NavLink page="patents" label="Patents" icon={BrainCircuit} />
          <NavLink page="apify" label="APIFY" icon={Zap} />
          <NavLink page="pubMed" label="PubMed" icon={BookMarked} />
          <NavLink page="scraping" label="Scraping" icon={FileSearch} />
          <NavLink page="gdelt" label="Gdelt" icon={Globe} />
        </nav>
        <div className="mt-auto">
          <div className="bg-gray-900/50 p-3 rounded-lg flex items-center gap-3">
            <UserCircle size={40} className="text-cyan-400" />
            <div className="flex-grow">
              <p className="font-semibold text-white">Admin User</p>
              <p className="text-xs text-gray-400">Administrator</p>
            </div>
            <button
              onClick={onLogout}
              title="Logout"
              className="text-gray-400 hover:text-white transition-colors p-2 rounded-md hover:bg-gray-700"
            >
              <LogOut size={20} />
            </button>
          </div>
        </div>
      </aside>
      <main className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
        {activePage === 'webScraping' && <WebScraping />}
        {activePage === 'patents' && <Patents />}
        {activePage === 'apify' && <Apify />}
        {activePage === 'pubMed' && <PubMed />}
        {activePage === 'scraping' && <Scraping />}
        {activePage === 'gdelt' && <Gdelt />}
      </main>
    </div>
  );
}

